import React from 'react';
import { CitiesProps } from './types';

export const Cities = ({
  city: { name, cityJobsPageUrl, slug },
  seeAllText,
}: CitiesProps) => {
  return (
    <a
      className="block my-2 xl:whitespace-nowrap"
      href={cityJobsPageUrl}
      id={slug}
    >
      {name}
    </a>
  );
};
